import './style.scss';

import {FC} from 'react';

import HomeIcon from '@mui/icons-material/Home';
import {Button, Typography} from '@mui/material';

import ROUTES from 'routes';

import {history} from "helpers/history";

const ErrorPage: FC = () => {
    return (
        <section className="status-page-403 bg-gradient-brand-blurred">
            <div className="status-page-403__container">
                <div className="status-page-403__content">
                    <Typography variant="h3" gutterBottom>
                        Coming soon
                    </Typography>
                    <Button
                        variant="contained"
                        data-testid="status-page-403-button"
                        onClick={() => history.push(ROUTES.mainPage.path)}
                        startIcon={<HomeIcon/>}
                    >
                        Back To home
                    </Button>
                </div>
            </div>
        </section>
    );
};

export default ErrorPage;
